import { UserStore } from './UserStore';

export const userStore = new UserStore();